var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
export var getGraphPlayLinePercent = function (_a) {
    var playLocationPercent = _a.playLocationPercent, playLocationTime = _a.playLocationTime, xAxisDomain = _a.xAxisDomain, zoomedTimeDomain = _a.zoomedTimeDomain;
    if (playLocationPercent <= 0)
        return;
    var _b = __read(xAxisDomain, 2), xStart = _b[0], xEnd = _b[1];
    var _c = __read(zoomedTimeDomain !== null && zoomedTimeDomain !== void 0 ? zoomedTimeDomain : xAxisDomain, 2), visibleStart = _c[0], visibleEnd = _c[1];
    var visibleSpan = visibleEnd - visibleStart;
    if (visibleSpan <= 0)
        return;
    var playTime = playLocationTime !== null && playLocationTime !== void 0 ? playLocationTime : xStart + playLocationPercent * (xEnd - xStart);
    var relativePosition = (playTime - visibleStart) / visibleSpan;
    return relativePosition > 0 && relativePosition < 1
        ? relativePosition
        : undefined;
};
